// extracted by mini-css-extract-plugin
export default {"SliderWrapper":"SlickCustomStyle_SliderWrapper__VPqdn"};